import { Controller } from "@hotwired/stimulus";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { addMapBackground } from "../utils/map_background";

// GO4SANALYTICS: one green dot per city, sized by the people in it. The
// positions come rounded to ~10 km (Cloudflare): a city, never an address.
// The view centres on Cameroon unless asked for the world.
const CAMEROON = { center: [6.0, 12.5], zoom: 6 };
const WORLD = { center: [12.0, 10.0], zoom: 2 };

export default class extends Controller {
  static targets = ["map", "data"];
  static values = {
    view: { type: String, default: "cameroon" },
    styleUrl: String,
    tileUrl: String,
    attribution: String,
    peopleLabel: { type: String, default: "personnes" },
  };

  connect() {
    if (!this.hasMapTarget) return;
    const points = this.hasDataTarget ? JSON.parse(this.dataTarget.textContent || "[]") : [];
    const view = this.viewValue === "world" ? WORLD : CAMEROON;

    this.map = L.map(this.mapTarget, { zoomControl: false, scrollWheelZoom: false, attributionControl: true })
      .setView(view.center, view.zoom);
    L.control.zoom({ position: "bottomright" }).addTo(this.map);
    addMapBackground(this.map, {
      styleUrl: this.styleUrlValue || undefined,
      tileUrl: this.tileUrlValue || undefined,
      attribution: this.attributionValue || undefined,
    });

    const max = Math.max(1, ...points.map((p) => p.people));
    points.forEach((p) => {
      L.circleMarker([p.latitude, p.longitude], {
        radius: 6 + Math.sqrt(p.people / max) * 22,
        color: "#47A534",
        weight: 2,
        fillColor: "#47A534",
        fillOpacity: 0.3,
      })
        .bindTooltip(`${this.escape(p.label || "")} · ${p.people} ${this.peopleLabelValue}`)
        .addTo(this.map);
    });

    // Frame the dots (Paris as well as Douala); Cameroon when there are none.
    if (points.length > 0 && this.viewValue !== "world") {
      const bounds = L.latLngBounds(points.map((p) => [p.latitude, p.longitude]));
      this.map.fitBounds(bounds, { padding: [40, 40], maxZoom: 7 });
    }

    this.resizeTimer = setTimeout(() => this.map && this.map.invalidateSize(), 200);
  }

  disconnect() {
    clearTimeout(this.resizeTimer);
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  escape(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
